import { ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef } from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'spa-autocomplete-template',
  templateUrl: './autocomplete-template.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutocompleteTemplateComponent {
  @Input() columnKey = '';
  @ContentChild(TemplateRef) template: TemplateRef<unknown> | undefined;
}
